/* eslint-disable import/prefer-default-export */
/**
 * Enum for commit frequencies.
 */
export enum CommitmentFrequencyEnum {
  OneTime = 'OneTime',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Semiannually = 'Semiannually',
  Annually = 'Annually',
}

export enum CommitmentIdEnum {
  NA = 'NA',
  ChildSponsorship = 'ChildSponsorship',
  Correspondence = 'Correspondence',
  FundCommitment = 'FundCommitment',
  GiftCommitment = 'GiftCommitment',
  Intervention = 'Intervention',
  LivingSponsorship = 'LivingSponsorship',
}

export enum CommitmentTypeEnum {
  NA = 'NA',
  ChildSponsorship = 'ChildSponsorship',
  Intervention = 'Intervention',
  FundCommitment = 'FundCommitment',
  Correspondence = 'Correspondence',
  LivingSponsorship = 'LivingSponsorship',
  GiftCommitment = 'GiftCommitment',
  GiftCatalog = 'GiftCatalog',
}

export enum CommitmentRecordTypeEnum {
  Donations = 'Donations',
  Gifts = 'Gifts',
  OngoingCommitments = 'Ongoing Commitments',
  Premiums = 'Premiums/Incentives/Stocks/Gifts In Kind',
}
